class ZgCopy {
  constructor() {
    this.$input = null;
    this._init();
  }
  _init() {
    $('body').append(`<input id="zg-copy-input" type="text"/>`);
    this.$input = $("#zg-copy-input");
  }
  copy(text) {
    this.$input.val(text);
    this.$input.select();
    document.execCommand("Copy");
    return text;
  }
}
const zgCopy = new ZgCopy();
const copyText = text => {
  return zgCopy.copy(text);
}

class MessageBox {
  constructor() {
    this.id = `popup-${new Date().getTime()}`;

    this.$popup = null;
    this.$popupBody = null;

    this._init();
  }
  _init() {
    this._createBox();
    this._event();
  }
  _createBox() {
    const boxHtml = /*html*/`
      <div id="${this.id}" class="zg-popup-wrapper">
        <div class="zg-popup">
          <div class="zg-popup-bg" data-popup-clear></div>
          <div class="zg-popup-ct">
            <div class="zg-popup-head">
              <button type="button" class="zg-popup-clear-btn" data-popup-clear><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M958.358489 152.199401l-89.399099-89.430822L511.17368 420.522566 153.388994 62.768579 63.988872 152.199401l357.785709 357.753987L63.988872 867.708398l89.400123 89.430822L511.17368 599.38421l357.785709 357.753987 89.399099-89.430822L600.573803 509.953388 958.358489 152.199401z"></path></svg></button>
            </div>
            <div class="zg-popup-body"><div>
          </div>
        </div>
      </div>
    `;
    $('body').append(boxHtml);
    this.$popup = $(`#${this.id}`);
    this.$popupBody = this.$popup.find(".zg-popup-body");
  }
  info(title, text) {
    const html = /*html*/`
      <div class="MessageBox-info">
        <h4>${title}</h4>
        <div>${text}</div>
      </div>
    `;
    this.$popupBody.html(html);
    this._show(3000);
  }
  _show(clearTime) {
    $("html").addClass('is-popup');
    this.$popup.fadeIn(() => {
      if (clearTime) {
        setTimeout(() => {
          this.clear();
        }, clearTime);
      }
    });
  }
  _event() {
    this.$popup.on('click', '[data-popup-clear]', ()=>{
      this.clear();
    })
  }
  clear() {
    this.$popup.fadeOut(() => {
      this.$popup.remove();
      $("html").removeClass('is-popup');
    })
  }
}

const messageBoxInfo = (title, text) => {
  const mb = new MessageBox();
  mb.info(title, text);
}

$(document).on('click', '[data-copy-text]', function () {
  const text = $(this).attr('data-copy-text');
  console.log(text);
  copyText(text);
  messageBoxInfo("コピーしました", "カート画面でご利用ください");
})

// Main Menu

const ammTime = 300;
const ammOpen = () => {
  const $amm = $("#shopify-section-main-menu");
  $('html').addClass('isDrawer');
  $amm.fadeIn(ammTime, function(){
    $(this).find('.zgdrawer-ct').animate({
      left: 0
    },ammTime)
  })
}  
const ammClose = () => {
  const $amm = $("#shopify-section-main-menu");
  $amm.find('.zgdrawer-ct').animate({
    left: "-320px"
  }, ammTime, function(){
    $amm.fadeOut(ammTime, ()=>{
      $('html').removeClass('isDrawer');
    });
  })
}
$(document).on('click', '[data-aside-main-menu-open]', function () {
  ammOpen();
})
$(document).on('click', '[data-aside-main-menu-close]', function () {
  ammClose();
})

// 产品
$("#productSelect").change(function (e) { 
  e.preventDefault()
  console.log($(this).val());
})


const getAddByZip = (zipcode) => {
  return new Promise((resolve, reject) => {
    if (window.ajaxAddByZip) window.ajaxAddByZip.abort();
    window.ajaxAddByZip = $.ajax({
      type: "GET",
      url: "https://zipcloud.ibsnet.co.jp/api/search",
      data: { zipcode },
      dataType: "json",
      success: function (res) {  //请求成功回调
        window.ajaxAddByZip = null;
        resolve(res)
      },
      error: function (e) {  //请求超时回调
        window.ajaxAddByZip = null;
        console.error(e);
      }
    })
  })
}

$('#create_customer #Zip').change(async function (e) { 
  e.preventDefault();
  let zip = $(this).val();
  console.log(zip);
  zip = zip.replace(/[^0-9]/ig,"");
  const res = await getAddByZip(zip);
  if (res.status === 200) {
    const $form = $(this).closest('form');
    $form.find("#Address1").val(res.results[0].address1);
    $form.find("#Address2").val(res.results[0].address2);
  }
  console.log(res);
})

$("#create_customer [name='customer[note][AccountType]']").change(function () {
  const $form = $(this).closest('form');
  let val = $(this).val();
  if (val === 'yes') {
    $form.find("#LealPerson").show().attr("required","true");
  } else {
    $form.find("#LealPerson").removeAttr("required").hide();
  }
});

$("#category-menu-wrapper-mobile .menu-item > .header").click(function (e) { 
  const $menuItem = $(this).closest('.menu-item');
  const $menu = $(this).closest('.menu');
  const $menuItemActive = $menu.find('.menu-item.active');
  if ($menuItem.hasClass('active')) {
    $menuItemActive.removeClass('active');
    $menuItemActive.find('.submenu').slideUp();
  } else {
    $menuItemActive.removeClass('active');
    $menuItemActive.find('.submenu').slideUp();
    $menuItem.addClass('active');
    $menuItem.find('.submenu').slideDown();
  }
});

$(".product-description-tab .nav.nav-tabs a").click(function (e) { 
  e.preventDefault()
  if ($(window).width() > 768) return;
  const tabpanelTop = $(".product-description-tab").offset().top;
  if (($(document).scrollTop() - 122) > tabpanelTop) {
    $("html,body").stop().animate({
      scrollTop: (tabpanelTop - 122)
    }, 300);
  }
})
